class ProductDiscovery extends HTMLElement {
  connectedCallback() {
    if (this.dataset.initialized === 'true') return;

    const previousRail = this.querySelector('[data-product-discovery-previous]');
    const nextRail = this.querySelector('[data-product-discovery-next]');
    const pool = this.querySelector('[data-product-discovery-pool]');

    if (!previousRail || !nextRail || !pool) return;

    const candidates = Array.from(pool.querySelectorAll('template[data-product-discovery-candidate]')).filter(
      (candidate) => candidate.content.querySelector('[data-product-discovery-card]')
    );

    this.dataset.initialized = 'true';

    if (candidates.length === 0) {
      pool.remove();
      return;
    }

    this.shuffle(candidates);

    const placements = [
      {
        rail: previousRail,
        label: this.dataset.previousLabel,
        className: 'product-discovery-card--previous',
      },
      {
        rail: nextRail,
        label: this.dataset.nextLabel,
        className: 'product-discovery-card--next',
      },
    ];

    placements.slice(0, Math.min(candidates.length, placements.length)).forEach((placement, index) => {
      const card = candidates[index].content.firstElementChild.cloneNode(true);
      const direction = card.querySelector('[data-product-discovery-direction]');
      const productLabel = card.getAttribute('aria-label');

      card.classList.add(placement.className);
      if (direction) direction.textContent = placement.label;
      if (productLabel) card.setAttribute('aria-label', `${placement.label}: ${productLabel}`);
      placement.rail.append(card);
    });

    if (candidates.length === 1) this.classList.add('product-discovery--single');
    pool.remove();
  }

  shuffle(items) {
    for (let index = items.length - 1; index > 0; index -= 1) {
      let swapIndex;

      if (window.crypto?.getRandomValues) {
        const randomValues = new Uint32Array(1);
        window.crypto.getRandomValues(randomValues);
        swapIndex = randomValues[0] % (index + 1);
      } else {
        swapIndex = Math.floor(Math.random() * (index + 1));
      }

      [items[index], items[swapIndex]] = [items[swapIndex], items[index]];
    }
  }
}

if (!customElements.get('product-discovery')) {
  customElements.define('product-discovery', ProductDiscovery);
}
